var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-content-loading',[_c('rect',{attrs:{"x":"0","y":"0","rx":"5","ry":"5","width":"100%","height":"30"}})])}
var staticRenderFns = []

export { render, staticRenderFns }